import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { SharedModule } from '../shared/shared.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';
import { AuthModule } from '../auth/auth.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BeneficiariesModule } from '../beneficiaries/beneficiaries.module';

@NgModule({
  declarations: [HeaderComponent, MenuComponent, FooterComponent],
  imports: [CommonModule, SharedModule, FontAwesomeModule, RouterModule, AuthModule, NgbModule, BeneficiariesModule],
  exports: [HeaderComponent, MenuComponent, FooterComponent],
})
export class CoreModule {}
